// Version gate cho `avatar init`: kiểm tra CLI local vs npm latest.
//
// Fail-soft design:
//   - Nếu không lấy được latest (offline / npm lỗi) → KHÔNG coi là outdated,
//     init vẫn chạy bình thường. Lỗi mạng không được chặn luồng init.
//
// Không dùng semver-compare phức tạp: triết lý đồng nhất với `avatar update` —
// "khác latest = nên update". Không phân biệt major/minor/patch vì:
//   - CLI thường có breaking change ngay cả minor.
//   - User luôn nên chạy bản mới nhất của dist-tag "latest".

import { readCliVersion } from "./read-cli-version-from-package-json.js";
import { fetchVersionForDistTag } from "./self-update-cli-via-npm-global-install.js";

export interface VersionGateResult {
  /** true CHỈ khi lấy được latest VÀ latest !== current */
  outdated: boolean;
  current: string;
  /** null = không lấy được (offline/npm lỗi) */
  latest: string | null;
}

export function checkCliVersionGate(): VersionGateResult {
  const current = readCliVersion();
  const latest = fetchVersionForDistTag("latest");

  // Offline hoặc npm lỗi → fail-soft, không chặn init.
  if (latest === null) {
    return { outdated: false, current, latest: null };
  }

  // Khác latest (kể cả trường hợp user đang chạy prerelease) → outdated.
  const outdated = latest !== current;
  return { outdated, current, latest };
}
